<template>
    <div class="mt-3" :style="`min-height: 450px;`">
        <div class="container">
            <div class="row mt-5 pb-1 mb-3 mb-xl-4 mt-sm-0 mb-sm-0">
                <div class="col-12 mb-xl-0 mb-0 mb-xl-3 ml-xl-0 ml-0 text-xl-left text-center">
                    <h2 class="font-glacial-bold font-70 ">
                        {{data.titulo}}
                    </h2>
                </div>
            </div>
        </div>

        <div ref="observerEventos"></div>
        <div class="container-fluid relacionados">
            <div class="row justify-content-center">
                <div class="col-xl-12 col-10">
                    <transition enter-active-class="animated fadeInUp">
                        <slick ref="slick" class="eventos pointer" :options="slickOptions" v-if="posts && showObserver">
                            <blog-item type="materia" class="text-white pr-1" :item="d" :large="index == 0 || index == 3" v-for="(d, index) in posts" :key="index"/>
                        </slick>
                    </transition>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center mb-4 pb-2 mt-4 pt-3 mt-xl-2 pt-xl-0">
            <b-button variant="ver-todas" class="col-xl-2 btn-opacidade" to="/eventos"></b-button>
        </div>
    </div>
</template>
<script>
import observer from 'intersection-observer';

export default {

    props:{
        data: null,
    },
    data(){
        return{
            posts: null,
            showObserver: false,

            slickOptions:{
                arrows: true,
                slidesToShow: 5,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings:{
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 700,
                        settings:{
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: 1366,
                        settings:{
                            slidesToShow: 3,
                        }
                    },
                ]
            }
        }
    },
    created() {
        this.loadPosts()
    },

    mounted(){
        var ob = new IntersectionObserver((entries) => {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) {
                return;
            }

            this.showObserver = true
            ob.unobserve(this.$refs.observerEventos)

        });
        ob.POLL_INTERVAL = 100;
        ob.observe(this.$refs.observerEventos)
    },

    methods:{
        async loadImg(url){
            let img = new Image();
            img.src = url
        },

        async loadPosts(){
                var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&categories=5"

                var response = await axios.get(url)
                this.posts = response.data
                
                this.posts.forEach(e => {
                    if (!e.better_featured_image) {
                        return
                    }
                    this.loadImg(e.better_featured_image.source_url)
                });
            },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/widgets/slider_eventos.vue